import * as tslib_1 from "tslib";
import { ElementRef, ViewContainerRef } from '@angular/core';
import { environment } from '../../../environment';
import { ESRI } from '../../../esri-loader-util';
import { InputConverter } from '../../../inputConverter';
import { LayerService } from '../../../services/layer.service';
import { BaseComponent } from '../../base.component';
import { BasemapConfigurationArrayConverter, CreateBasemapsFromConfig } from './basemap-config';
var Basemap;
var BasemapGallery;
var BasemapSwitcherComponent = /** @class */ (function (_super) {
    tslib_1.__extends(BasemapSwitcherComponent, _super);
    function BasemapSwitcherComponent(_vcr, layerService) {
        var _this = 
        //do not indicate ready until the first initialization of the gallery
        //has been completed to load the values of this basemap from current
        //properties
        _super.call(this, _vcr, false) || this;
        _this.layerService = layerService;
        _this.basemapConfigs = [];
        _this.basemaps = '';
        _this.esriBasemaps = [];
        _this.bingSupplementaryIds = ['BingMapsRoad', 'BingMapsAerial', 'BingMapsHybrid'];
        _this.possibleSupplementaryIds = tslib_1.__spread(_this.bingSupplementaryIds);
        _this._shouldSetup = false;
        _this.finishSetup();
        return _this;
    }
    BasemapSwitcherComponent.prototype.addBasemaps = function (basemapIds, basemapConfigs) {
        if (Array.isArray(basemapIds)) {
            basemapIds = basemapIds.join(',');
        }
        this.basemaps = basemapIds;
        this.basemapConfigs = basemapConfigs;
        //shouldSetup will fire the setter function but does not block
        //this call from resolving before loadBasemapGallery is called.
        //A future implementation may want to consider this to ensure data
        //integrity at time of completing this function
        this.shouldSetup = true;
    };
    Object.defineProperty(BasemapSwitcherComponent.prototype, "shouldSetup", {
        get: function () { return this._shouldSetup; },
        set: function (value) {
            this._shouldSetup = value;
            if (value) {
                //on setup perform a full load of the basemap gallery as both setupBasemaps
                //and createBasemapGallery must be called
                this.loadBasemapGallery();
            }
        },
        enumerable: true,
        configurable: true
    });
    BasemapSwitcherComponent.prototype.finishSetup = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.loadBasemapGallery()];
                    case 1:
                        _a.sent();
                        this.isReady();
                        return [2 /*return*/];
                }
            });
        });
    };
    BasemapSwitcherComponent.prototype.loadBasemapGallery = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: 
                    //filter out supplementary IDs out of the basemap IDs so they do not get passed down to ESRI
                    return [4 /*yield*/, this.setMapViewRef()];
                    case 1:
                        //filter out supplementary IDs out of the basemap IDs so they do not get passed down to ESRI
                        _a.sent();
                        return [4 /*yield*/, this.setupBasemaps()];
                    case 2:
                        _a.sent();
                        return [4 /*yield*/, this.createSupplementaryBasemaps()];
                    case 3:
                        _a.sent();
                        return [4 /*yield*/, this.createBasemapGallery()];
                    case 4:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    BasemapSwitcherComponent.prototype.setMapViewRef = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var parent_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!!this.mapViewRef) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.getClosestAncestor('mc-map')];
                    case 1:
                        parent_1 = _a.sent();
                        if (!parent_1) return [3 /*break*/, 3];
                        return [4 /*yield*/, parent_1.ready];
                    case 2:
                        _a.sent();
                        this.mapViewRef = parent_1.mapView;
                        return [3 /*break*/, 4];
                    case 3:
                        this.readyProblem('Map View Reference not supplied and reference from parent element could not be retrieved.');
                        _a.label = 4;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    BasemapSwitcherComponent.prototype.setupBasemaps = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.esriBasemaps = [];
                        return [4 /*yield*/, this.createBasemapsFromConfig()];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.createBasemapsFromIds()];
                    case 2:
                        _a.sent();
                        this.shouldSetup = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    BasemapSwitcherComponent.prototype.createBasemapsFromConfig = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var e_1, _a, _b, _c, item, _d, _e, e_1_1;
            return tslib_1.__generator(this, function (_f) {
                switch (_f.label) {
                    case 0:
                        _f.trys.push([0, 6, 7, 8]);
                        _b = tslib_1.__values(this.basemapConfigs), _c = _b.next();
                        _f.label = 1;
                    case 1:
                        if (!!_c.done) return [3 /*break*/, 5];
                        item = _c.value;
                        if (!!this.basemapExists(item.title)) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.layerService.getLayerCopyRight(item)];
                    case 2:
                        _f.sent();
                        _e = (_d = this.esriBasemaps).push;
                        return [4 /*yield*/, CreateBasemapsFromConfig(item)];
                    case 3:
                        _e.apply(_d, [_f.sent()]);
                        _f.label = 4;
                    case 4:
                        _c = _b.next();
                        return [3 /*break*/, 1];
                    case 5: return [3 /*break*/, 8];
                    case 6:
                        e_1_1 = _f.sent();
                        e_1 = { error: e_1_1 };
                        return [3 /*break*/, 8];
                    case 7:
                        try {
                            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                        }
                        finally { if (e_1) throw e_1.error; }
                        return [7 /*endfinally*/];
                    case 8: return [2 /*return*/];
                }
            });
        });
    };
    BasemapSwitcherComponent.prototype.createBasemapsFromIds = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, e_2, _b, basemapArr, basemapArr_1, basemapArr_1_1, item;
            var _this = this;
            return tslib_1.__generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (!!Basemap) return [3 /*break*/, 2];
                        return [4 /*yield*/, Promise.all([ESRI.Basemap])];
                    case 1:
                        _a = tslib_1.__read.apply(void 0, [_c.sent(), 1]), Basemap = _a[0];
                        _c.label = 2;
                    case 2:
                        basemapArr = this.basemaps.split(',').map(function (x) { return x.trim(); });
                        basemapArr = basemapArr.filter(function (item) { return !_this.possibleSupplementaryIds.includes(item); });
                        try {
                            for (basemapArr_1 = tslib_1.__values(basemapArr), basemapArr_1_1 = basemapArr_1.next(); !basemapArr_1_1.done; basemapArr_1_1 = basemapArr_1.next()) {
                                item = basemapArr_1_1.value;
                                if (!this.basemapExists(item)) {
                                    this.esriBasemaps.push(Basemap.fromId(item));
                                }
                            }
                        }
                        catch (e_2_1) { e_2 = { error: e_2_1 }; }
                        finally {
                            try {
                                if (basemapArr_1_1 && !basemapArr_1_1.done && (_b = basemapArr_1.return)) _b.call(basemapArr_1);
                            }
                            finally { if (e_2) throw e_2.error; }
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    /*
    * Additional unique identifiers to add an abstract set of possible basemaps. Currently this
    * is used to implement Bing Road, Imagery, and Hybrid maps in case the using program requires
    * this maps
    */
    BasemapSwitcherComponent.prototype.createSupplementaryBasemaps = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var e_3, _a, _b, i, basemapArr, supplementaryIds, supplementaryIds_1, supplementaryIds_1_1, supp, BingMapLayer, mapProps, opacityModifier, e_3_1;
            var _this = this;
            return tslib_1.__generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        i = 0;
                        basemapArr = this.basemaps.split(',').map(function (x) { return x.trim(); });
                        supplementaryIds = basemapArr.filter(function (item) { return _this.possibleSupplementaryIds.includes(item); });
                        _c.label = 1;
                    case 1:
                        _c.trys.push([1, 6, 7, 8]);
                        supplementaryIds_1 = tslib_1.__values(supplementaryIds), supplementaryIds_1_1 = supplementaryIds_1.next();
                        _c.label = 2;
                    case 2:
                        if (!!supplementaryIds_1_1.done) return [3 /*break*/, 5];
                        supp = supplementaryIds_1_1.value;
                        BingMapLayer = void 0;
                        return [4 /*yield*/, Promise.all([ESRI.Basemap, ESRI.BingMapsLayer])];
                    case 3:
                        _b = tslib_1.__read.apply(void 0, [_c.sent(), 2]), Basemap = _b[0], BingMapLayer = _b[1];
                        //handle bing specific supplementary basemaps
                        if (this.bingSupplementaryIds.includes(supp)) {
                            mapProps = {
                                style: undefined,
                                title: '',
                                thumbnailUrl: '',
                                id: "" + supp + i
                            };
                            switch (supp) {
                                case 'BingMapsRoad':
                                    mapProps.style = 'road';
                                    mapProps.title = 'Bing Streets';
                                    mapProps.thumbnailUrl = environment.bingBasemaps.thumbnails.street;
                                    break;
                                case 'BingMapsAerial':
                                    mapProps.style = 'aerial';
                                    mapProps.title = 'Bing Imagery';
                                    mapProps.thumbnailUrl = environment.bingBasemaps.thumbnails.imagery;
                                    break;
                                case 'BingMapsHybrid':
                                    mapProps.style = 'hybrid';
                                    mapProps.title = 'Bing Imagery w/ Labels';
                                    mapProps.thumbnailUrl = environment.bingBasemaps.thumbnails.hybrid;
                                    break;
                                default:
                                    break;
                            }
                            opacityModifier = 0.000001;
                            this.esriBasemaps.push(new Basemap(tslib_1.__assign({ baseLayers: [
                                    new BingMapLayer(tslib_1.__assign({}, mapProps, { key: environment.bingBasemaps.key, opacity: 1 - opacityModifier * i //this setting of opacity is a work around for ESRI comparisons that just take into consideration type, url, min scale, max scale, visibility, and opacity. In the
                                     }))
                                ] }, mapProps)));
                        }
                        i++;
                        _c.label = 4;
                    case 4:
                        supplementaryIds_1_1 = supplementaryIds_1.next();
                        return [3 /*break*/, 2];
                    case 5: return [3 /*break*/, 8];
                    case 6:
                        e_3_1 = _c.sent();
                        e_3 = { error: e_3_1 };
                        return [3 /*break*/, 8];
                    case 7:
                        try {
                            if (supplementaryIds_1_1 && !supplementaryIds_1_1.done && (_a = supplementaryIds_1.return)) _a.call(supplementaryIds_1);
                        }
                        finally { if (e_3) throw e_3.error; }
                        return [7 /*endfinally*/];
                    case 8: return [2 /*return*/];
                }
            });
        });
    };
    BasemapSwitcherComponent.prototype.createBasemapGallery = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        //when the basemapGallery already has been initialized, remove all the
                        //basemaps from it, add the set we currently have, refresh to force the
                        //Gallery to reload from the source array and force a new render of the gallery
                        //this allows for an inplace update of the existing gallery with no deconstruction
                        //and is needed since addBasemaps will add additional basemaps after initialization
                        //of the gallery has been completed.
                        if (this.basemapGallery) {
                            this.basemapGallery.source.basemaps.removeAll();
                            this.basemapGallery.source.basemaps.addMany(this.esriBasemaps);
                            this.basemapGallery.source.refresh();
                            this.basemapGallery.renderNow();
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, Promise.all([ESRI.BasemapGallery])];
                    case 1:
                        _a = tslib_1.__read.apply(void 0, [_b.sent(), 1]), BasemapGallery = _a[0];
                        this.basemapGallery = new BasemapGallery({
                            container: this.basemapSwitcherAreaRef.nativeElement,
                            source: this.esriBasemaps,
                            view: this.mapViewRef
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    BasemapSwitcherComponent.prototype.basemapExists = function (id) {
        return this.esriBasemaps.find(function (x) { return x.id === id; });
    };
    tslib_1.__decorate([
        InputConverter(BasemapConfigurationArrayConverter),
        tslib_1.__metadata("design:type", Array)
    ], BasemapSwitcherComponent.prototype, "basemapConfigs", void 0);
    return BasemapSwitcherComponent;
}(BaseComponent));
export { BasemapSwitcherComponent };
